import { render, staticRenderFns } from "./ArchiveStatuses.vue?vue&type=template&id=7768c140"
import script from "./ArchiveStatuses.vue?vue&type=script&lang=js"
export * from "./ArchiveStatuses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports